export enum AuthRole {
    PTAdmin = "PTAdmin",
    PT = "PT",
    User = "User",
    Developer = "Developer",
    ExternalApi = "ExternalApi"
}